export enum LoginActionType {
  LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGIN_ERROR,
  LOGIN_FIELD,
}

export interface Login {
  email: string;
  password: string;
  isLoading: boolean;
  error: string;
  isLoggedIn: boolean;
}

export type LoginAction = {
  type: LoginActionType;
  payload?: any;
};
